import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

interface BasicApiPagination {
  authToken: string;
  registros: number;
  pagina: number;
}

interface RevendaUnidadeListar extends BasicApiPagination {
  isDataCriacao: boolean;
  minhasIndicacoes: boolean | null;
  mobiliado: boolean | null;
  dataInicio?: Date | null;
  dataFim?: Date | null;
  idRevendaEmpreendimento: string;
  idRevendaEmpreendimentoTorre: string;
  vagas?: number | null;
  areaUtil: number | null;
  idRevendaRegiao: string;
  metragemDe?: number | null;
  metragemAte?: number | null;
  valorDe?: number | null;
  valorAte?: number | null;
  status?: number[];
}

/**
 * Função para cadastrar uma unidade de revenda.
 *
 * @param {RevendaUnidadeListar} params - Parâmetros para cadastro da unidade de revenda.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postRevendaUnidadeListar = async (
  params: RevendaUnidadeListar
): Promise<any> => {
  const url = "/api/RevendaUnidade/ListarPorFiltro";
  const { authToken, ...parameters } = params;
  const _parameters = {
    ...parameters,
    minhasIndicacoes:
      typeof parameters.minhasIndicacoes !== "boolean"
        ? null
        : parameters.minhasIndicacoes,
    mobiliado:
      typeof parameters.mobiliado !== "boolean" ? null : parameters.mobiliado,
    vagas: typeof parameters.vagas !== "number" ? null : parameters.vagas,
    valorDe: typeof parameters.valorDe !== "number" ? null : parameters.valorDe,
    valorAte:
      typeof parameters.valorAte !== "number" ? null : parameters.valorAte,
    metragemDe:
      typeof parameters.metragemDe !== "number" ? null : parameters.metragemDe,
    metragemAte:
      typeof parameters.metragemAte !== "number"
        ? null
        : parameters.metragemAte,
    areaUtil:
      typeof parameters.areaUtil !== "number" ? null : parameters.areaUtil,
    idRevendaEmpreendimento: parameters.idRevendaEmpreendimento
      ? parameters.idRevendaEmpreendimento
      : null,
    idRevendaEmpreendimentoTorre: parameters.idRevendaEmpreendimentoTorre
      ? parameters.idRevendaEmpreendimentoTorre
      : null,
    idRevendaRegiao: parameters.idRevendaRegiao
      ? parameters.idRevendaRegiao
      : null,
  };
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, _parameters, config);
  return response?.data;
};
